module.exports = __webpack_public_path__ + "img/health-fill.9afdb66e.svg";